// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import {
  CHANGE_STATUS_PURCHASE_ORDER,
  CREATE_PURCHASE_ORDER,
  DELETE_PURCHASE_ORDER,
  GET_DETAIL_PURCHASE_ORDER,
  GET_LIST_PURCHASE_ORDER,
  UPDATE_PURCHASE_ORDER,
} from '~/utils/constants/actionType';
import {
  IFormPurchaseOrder,
  IFormChangeStatusPO,
  IQueryParamPurchaseOrder,
  IQueryDetailPurchaseOrder,
} from '~/utils/interface/purchaseOrder';
import purchaseOrderApi from '~/apis/purchaseOrder';
import { IBodyUpdate } from '~/utils/interface/common';

export const getListPurchaseOrder = createAsyncThunk(
  GET_LIST_PURCHASE_ORDER,
  async (params: IQueryParamPurchaseOrder, { rejectWithValue }) => {
    try {
      const resp = await purchaseOrderApi.getListPurchaseOrder(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailPurchaseOrder = createAsyncThunk(
  GET_DETAIL_PURCHASE_ORDER,
  async (query: IQueryDetailPurchaseOrder, { rejectWithValue }) => {
    try {
      const resp = await purchaseOrderApi.getDetailPurchaseOrder(query);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createPurchaseOrder = createAsyncThunk(
  CREATE_PURCHASE_ORDER,
  async (body: IFormPurchaseOrder, { rejectWithValue }) => {
    try {
      const resp = await purchaseOrderApi.createPurchaseOrder(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updatePurchaseOrder = createAsyncThunk(
  UPDATE_PURCHASE_ORDER,
  async (params: IBodyUpdate<IFormPurchaseOrder>, { rejectWithValue }) => {
    try {
      const resp = await purchaseOrderApi.updatePurchaseOrder(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deletePurchaseOrder = createAsyncThunk(DELETE_PURCHASE_ORDER, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await purchaseOrderApi.deletePurchaseOrder(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const changeStatusPurchaseOrder = createAsyncThunk(
  CHANGE_STATUS_PURCHASE_ORDER,
  async (params: IBodyUpdate<IFormChangeStatusPO>, { rejectWithValue }) => {
    try {
      const resp = await purchaseOrderApi.changeStatusPurchaseOrder(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
